'use strict';
module.exports = [
  // type
  require('./BigNumber'),

  // construction function
  require('./function/bignumber')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/bignumber/index.js
// module id = 1333
// module chunks = 0